<template>
  <div class="content-page">
    <!-- Start content -->
    <div class="content">
      <div class="container-fluid">
        <div class="page-title-box">
          <div class="row align-items-center">
            <div class="col-sm-6">
              <h4 class="page-title">
                <font color="white">COLLECTIONS</font>
              </h4>
            </div>
               <div class="col-sm-6">
                  <div class="form-group col-md-4" style="float: right">
                      <select id="inputState" class="form-control" style="margin-top: 15px" @change="setDesiredBranch($event)">
                          <option selected value="">All Branch</option>
                          <option  v-for="branch in branches" :key="branch.branch_id" :value="branch.branch_id">{{ branch.branch_name }}</option>
                      </select>
                  </div>
               </div>
          </div>
        </div>
        
        <!-- end row -->
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body" style="overflow: scroll;">
                <h4 class="mt-0 header-title">Export</h4>
                <table
                  v-if="!spinner"
                  id="example2"
                  class="table table-striped table-bordered dt-responsive nowrap text-center"
                  style="border-collapse: collapse; border-spacing: 0; width: 100%;"
                >
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Reference</th>
                      <th>Amount (NGN)</th>
                      <th>Receiver</th>
                      <th>Transaction Information</th>
                      <th>Channel</th>
                      <th>Date Paid</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="transactions.length == 0">
                      <td colspan="7">No recent Transactions...</td>
                    </tr>
                    <tr v-else v-for="(item, index) in transactions" :key="index">
                      <td>
                        <i
                          :class="[(item.status.toLowerCase() == 'pending')?'fa fa-circle text-warning': 'fa fa-circle text-success']"
                        ></i>
                        {{ item.status }}
                      </td>
                      <td>{{ item.transaction_id }}</td>
                      <td>{{ item.amount }}</td>
                      <td>{{ item.receiver }}</td>
                      <td>{{ item.title }}</td>
                      <td>USSD</td>
                      <td>{{ item.date }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="spinner" class="text-center">
                <p>
                  <i class="fa fa-spinner fa-spin fa-3x"></i>
                </p>
              </div>
            </div>
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- container-fluid -->
    </div>
    <!-- content -->
  </div>
</template>
<script>
import { setTimeout } from "timers";
let table = null;

export default {
  mounted() {
    this.fields.username = sessionStorage.getItem("username");
    this.fields.user_id = sessionStorage.getItem("userid");
    this.getTransaction();
    this.getBranch();
    setTimeout(() => {
      table = $("#example2").DataTable({
        destroy: true,
        order: [[6, "desc"]],
        dom: "Bfrtip",
        buttons: ["copyHtml5", "excelHtml5", "csvHtml5", "pdfHtml5"]
      });
    }, 3000);
  },
  beforeUpdate()
  {
    table.destroy();
  }
  ,
  data() {
    return {
      fields: {
        action: "get_transactions",
        service: "collections",
        branch: ''
      },
      transactions: [],
      spinner: false,
      branches: null,
      branch: '',
    };
  },

  methods: {
      hash(ref) {
        let passcode = "123NDSx";
        let encrypted = CryptoJS.HmacSHA512(ref, passcode);
        return encrypted.toString();
      },

      setDesiredBranch(event)
      {
        this.branch = event.target.value;
        this.getTransaction()
      },

     getBranch(){
                this.spinner = true;
                let user_id = sessionStorage.getItem("userid");
                let username = sessionStorage.getItem("username");

                var obj = {
                    'action': 'get_branches', 
                    'username': username,
                    'user_id':user_id,
                    'passcode':this.hash(username)
                };

               
                this.axios.post("https://irecharge.com.ng/api/collections/get_branches.php",obj)
                .then(response => {
                    if (response.data.status == "0") {
                        this.branches = response.data.items
                        // this.spinner = false;
                    } else {
                        if (response.data.message) {
                            this.$noty.error(response.data.message);
                            this.spinner = false;

                        }
                    
                    }
                
                    }).catch(error => {
                        this.$noty.error("Error occured. Try again");
                    });

                {
            
            }

        },

    getTransaction() {
      //show the loader
      this.spinner = true;
      this.fields.passcode = this.hash(this.fields.username);
      this.fields.branch = this.branch;
      console.log('here',this.fields.branch, this.branch);

      this.axios
        .post(
          "https://irecharge.com.ng/api/collections/get_transactions.php",
          this.fields
        )
        .then(response => {
          if (response.data.status == "0") {

            if (response.data.transactions) {
              this.transactions = response.data.transactions;
            }
          } else {
            // if it's -1 noty
            this.$noty.danger(response.data.message);
          }
          //hide the loader
          this.spinner = false;
        })
        .catch(error => {
          // console.log('error')
          // console.log(error)

          //hide the loader
          this.spinner = false;
        });
    }
  }
};
</script>
<style scoped>
</style>